import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

export default function SchoolNameStep({ formData, setFormData }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <h2>{t("Start.schoolName")}</h2>
      <input
        ref={inputRef}
        type="text"
        value={formData.schoolName}
        onChange={e =>
          setFormData({
            ...formData,
            schoolName: e.target.value
          })
        }
      />
    </>
  );
}
